import React from 'react';
import { PanelLayout } from '../../layout/Panel/Panel';
import { Spacing } from '../../layout/Spacing/Spacing';
import { TextCustom } from '../../ui/TextCustom';
import { TColorRole, TSize } from '../../../types/types';
import { LoaderThreeDots } from '../../shared/Loader/LoaderThreeDots';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';


interface IChatBubbleProps {
    isText?: boolean;
    label: string;
    maxWidth?: number;
    colorBorder?: TColorRole;
    borderIntensity?: number;
    color?: TColorRole;
    colorIntensity?: number;
    paddingSpacing?: TSize;
    textColor?: TColorRole;
    textSize?: number;
}

export const ChatBubble: React.FC<IChatBubbleProps> = ({
    isText = true,
    label,
    maxWidth = 250,
    colorBorder = 'dark',
    borderIntensity = 0.3,
    color = 'dark',
    colorIntensity = 0.1,
    paddingSpacing = 'm',
    textColor = 'dark',
    textSize = 1.2,
}) => {
    

    return (
        <div style={{ maxWidth: `300px` }}>
            <PanelLayout colorBorder={colorBorder} borderIntensity={borderIntensity} hasShadow={false} color={color} colorIntensity={colorIntensity}>
                <Spacing marginSpacing="none" paddingSpacing={paddingSpacing}>
                    {isText ? (
                        <TextCustom breakText={false} size={textSize} color={textColor}>
                            {/* <SyntaxHighlighter language="html" >
                            {label}
                            </SyntaxHighlighter> */}
                            <ReactMarkdown
                                className="markdown"
                                unwrapDisallowed={true}
                                skipHtml={false}
                                allowedElements={['p', 'strong', 'li', 'ol', 'ul', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div']}
                                rehypePlugins={[rehypeRaw]}
                                components={
                                    {
                                        // a: ({ ...props }) => <a style={{color:'blue'}} {...props} />,
                                        // strong: ({ ...props }) => <div style={{backgroundColor:'red'}}><strong {...props} /></div>,
                                        // p: ({ ...props }) => <p style={{fontWeight:'bold'}} {...props} />,
                                        // li: ({ ...props }) => <li style={{color:'purple'}} {...props} />,
                                        // div: ({ node, ...props }) => <div {...props} />, // Dozvoljava renderovanje <div> tagova
                                    }
                                }
                            >
                                {
                                    label
                                }
                            </ReactMarkdown>
                        </TextCustom>
                    ) : (
                        <LoaderThreeDots hasText={false} height={20} width={20} radius={9} color="dark" />
                    )}
                </Spacing>
            </PanelLayout>
        </div>
    );
};
